<template>
  <div class="finance">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.crmid"/>
          <div v-if="!orderId || formData.id || loading" class="table-agile-info" v-loading="loading">
            <template v-if="orderId">
              <el-alert
                v-if="formData.commission_status < 2"
                show-icon
                title="该订单需要外联老师进行审核确认后生效，请及时联系。"
                type="warning" />
              <el-alert
                v-if="formData.commission_status > 2"
                show-icon
                :title="formData.commission_status === 3 ? '该订单已被外联老师审核通过，修改后需重新审核。' : '该订单已经自动通过佣金审核。'"
                type="success" />
            </template>
            <div class="common-new-title mode2">
              <span>前程订单信息</span>
            </div>
            <el-row class="info-manag-wrap">
              <el-col :lg="8" :md="12" :sm="24">
                <label>订单编号:</label>
                <span>{{ formData.order_no || '自动生成' }}</span>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label>学生姓名:</label>
                <span>{{ pageDs.custom_name }}</span>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label>入学时间:</label>
                <span>{{ pageDs.custom_year }}</span>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label><i style="color: red">*</i>发起人:</label>
                <el-select
                  v-if="$hasPermission(1)"
                  v-model="formData.create_uid"
                  filterable
                  clearable
                  class="jm-input220"
                  placeholder="请选择">
                  <el-option-group
                    v-for="(group, k) in pageDs.create_list"
                    :key="k"
                    :label="k">
                    <el-option
                      v-for="item in group"
                      v-show="item.userid > 0"
                      :key="item.userid"
                      :label="item['username']"
                      :value="item['userid']"/>
                  </el-option-group>
                </el-select>
                <span v-else>{{ formData.teacher_name }}</span>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label><i style="color: red">*</i>所属部门:</label>
                <span>前程日本</span>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label>加项订单:</label>
                <jm-dict-select
                  clearable
                  class="jm-input220"
                  v-model="formData.is_plus"
                  dict="online.is_plus"/>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label><i style="color: red">*</i>新单/补尾款:</label>
                <el-select
                  filterable
                  clearable
                  v-model="formData.is_renewal"
                  class="jm-input220"
                  placeholder="请选择">
                  <el-option label="新单" :key="1" :value="1" />
                  <el-option label="补尾款" :key="2" :value="2" />
                </el-select>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label>代签:</label>
                <el-select
                  v-model="formData.allograph_uid"
                  filterable
                  clearable
                  class="jm-input220"
                  placeholder="请选择">
                  <el-option-group
                    v-for="(group, k) in pageDs.create_list"
                    :key="k"
                    :label="k">
                    <el-option
                      v-for="item in group"
                      v-show="item.userid > 0"
                      :key="item.userid"
                      :label="item['username']"
                      :value="item['userid']"/>
                  </el-option-group>
                </el-select>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label>代签办事处:</label>
                <el-select
                  filterable
                  clearable
                  v-model="formData.allograph_office"
                  class="jm-input220"
                  placeholder="请选择">
                  <el-option label="大连" value="大连" />
                  <el-option label="北京" value="北京" />
                  <el-option label="上海" value="上海" />
                  <el-option label="广州" value="广州" />
                  <el-option label="东京" value="东京" />
                </el-select>
              </el-col>

              <el-col :span="24">
                <label><i style="color: red">*</i>订单名称:</label>
                <el-input
                  clearable
                  v-model="formData.order_title"
                  class="jm-input400"/>
                <el-button
                  type="success"
                  size="mini"
                  style="margin-left: 10px"
                  :disabled="!formData.goods_list.length"
                  @click="fetchOrderTitle">自动提取</el-button>
              </el-col>
              <el-col :span="24">
                <label>所申学校:</label>
                <school-multiple-search
                  class="jm-input400"
                  placeholder="请输入学校关键字"
                  :default-options.sync="formData.apply_school_list"
                  @change="schoolChange"
                  :country-sh-mg-id="0"
                  :value.sync="formData.apply_school_ids"></school-multiple-search>
                <span class="tip-text">如学生未确定学校无需填写</span>
              </el-col>
              <el-col :span="24">
                <label>订单备注:</label>
                <el-input
                  style="vertical-align: top"
                  resize="none"
                  type="textarea"
                  rows="5"
                  v-model="formData.order_memo"
                  class="jm-input400"/>
              </el-col>
            </el-row>

            <!--列表部分 start -->
            <div class="common-new-title mode2">
              <span>商品列表</span>
              <div class="custom-area">
                <a href="https://www.safe.gov.cn" target="_blank" style="color:green">
                  <i class="el-icon-date"></i> 查询当月汇率
                </a>
                <el-button type="primary" size="small" icon="el-icon-goods" style="margin-left: 10px" @click="openGoodDialog">添加商品</el-button>
              </div>
            </div>
            <el-table
              ref="goodTable"
              :data="formData.goods_list">
              <el-table-column
                prop="goods_id"
                label="商品编号">
              </el-table-column>
              <el-table-column
                prop="goods_title"
                label="商品名称">
              </el-table-column>
              <el-table-column
                prop="srv_fullcase_str"
                label="产品类目">
              </el-table-column>
              <el-table-column
                prop="deposit_fee"
                label="押金">
                <template slot-scope="scope">
                  <div class="flex-wrap">
                    <el-input v-model="scope.row.deposit_fee" type="number" @input="changeGoodsList()" style="margin-right: 4px"></el-input>
                    <el-popover
                      v-show="scope.row.srv_price['押金'] && Number(scope.row.srv_price['押金']) !== 0"
                      placement="top"
                      width="200"
                      trigger="hover"
                      :content="priceFormat(scope.row.srv_price['押金'])">
                      <i slot="reference" class="el-icon-info" style="color:#F75694"></i>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="signup_fee"
                label="报名费">
                <template slot-scope="scope">
                  <div class="flex-wrap">
                    <el-input v-model="scope.row.signup_fee" type="number" @input="changeGoodsList()" style="margin-right: 4px"></el-input>
                    <el-popover
                      v-show="scope.row.srv_price['报名费'] && Number(scope.row.srv_price['报名费']) !== 0"
                      placement="top"
                      width="200"
                      trigger="hover"
                      :content="priceFormat(scope.row.srv_price['报名费'])">
                      <i slot="reference" class="el-icon-info" style="color:#F75694"></i>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="service_fee"
                label="服务费">
                <template slot-scope="scope">
                  <div class="flex-wrap">
                    <el-input v-model="scope.row.service_fee" type="number" @input="changeGoodsList()" style="margin-right: 4px"></el-input>
                    <el-popover
                      v-show="scope.row.srv_price['服务费'] && Number(scope.row.srv_price['服务费']) !== 0"
                      placement="top"
                      width="200"
                      trigger="hover"
                      :content="priceFormat(scope.row.srv_price['服务费'])">
                      <i slot="reference" class="el-icon-info" style="color:#F75694"></i>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="need_fee"
                label="应付金额">
                <div slot-scope="scope">
                  {{ Number(scope.row.need_fee) }}
                </div>
              </el-table-column>
              <el-table-column
                v-if="showCommission"
                prop="commission_fee"
                label="佣金参考">
                <template slot-scope="scope">
                  <div class="flex-wrap">
                    <el-input type="number" v-model="scope.row.commission_fee"></el-input>
                    <el-popover
                      v-show="scope.row.srv_price['佣金'] && Number(scope.row.srv_price['佣金']) !== 0"
                      placement="top"
                      width="200"
                      trigger="hover"
                      :content="priceFormat(scope.row.srv_price['佣金'])">
                      <i slot="reference" class="el-icon-info" style="color:#F75694"></i>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                align="center"
                header-align="center"
                width="140"
                label="操作">
                <template slot-scope="scope">
                  <div>
                    <el-button type="danger" @click="deleteGood(scope.$index)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <!--列表部分 end-->
            <div class="table-agile-info" style="color:#aaa">
              <p>说明：① 应付金额 = 押金 + 报名费 + 服务费
                <template v-if="showCommission">
                  &nbsp; ② 合同额 / 预付账款 / 销售额 = 服务费 + 佣金
                </template>
              </p>
            </div>
            <el-row class="info-manag-wrap" style="margin-top: 10px">
              <el-col v-if="showCommission" :lg="8" :md="12" :sm="24">
                <label>合同额（含佣金）:</label>
                <span>{{ formData.pre_fee }}</span>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label>应付总额:</label>
                <span>{{ formData.need_fee }}</span>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label class="form-tit">押金总额:</label>
                <span>{{ formData.deposit_fee }}</span>
              </el-col>

              <el-col v-if="!showCommission" :lg="8" class="hidden-md-and-down" />
              <el-col :lg="8" :md="12" :sm="24">
                <label class="form-tit">订单首款:</label>
                <el-input type="number" v-model="formData.first_fee" class="jm-input220"/>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label class="form-tit"><i style="color: red">*</i>缴费截止日期:</label>
                <el-date-picker
                  type="date"
                  class="jm-input220"
                  v-model="formData.last_payment_date"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-col>
            </el-row>
            <!--按钮 start-->
            <div class="jm-button-wrap jm-tac">
              <template v-if="this.formData.id">
                <!--超管显示“修改订单”和“佣金确认”，其他人员只显示其中一个-->
                <el-button v-if="$hasPermission(1)" type="primary" @click="orderSave({})" :loading="btnLoading">
                  修改订单
                </el-button>
                <el-button v-if="$hasPermission(173)" type="success" @click="orderSave({ commission_confirmed: 1 })" :loading="btnLoading">
                  佣金确认
                </el-button>
                <el-button v-else type="primary" @click="orderSave({})" :loading="btnLoading">
                  修改订单
                </el-button>
              </template>
              <template v-else>
                <el-button type="primary" @click="orderSave({})" :loading="btnLoading">
                  创建订单
                </el-button>
              </template>
            </div>
            <!--按钮 end-->
          </div>
          <jm-empty v-else :description="loading ? '正在加载中 ...' : '订单数据不存在或者已删除'" />
          <!--添加商品 start-->
          <el-dialog
            title="添加商品"
            :visible="goodDialogLock"
            width="600px"
            :show-close="false">
            <el-form label-width="120px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="商品名称：">
                    <el-select class="jm-input400" @change="goodChange" v-model="goodDialogForm.goods_title" placeholder="请选择" filterable>
                      <el-option
                        v-for="(item, index) in pageDs.goods"
                        :key="index"
                        :label="item.goods_title"
                        :value="index">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="产品编号：">
                    <span>{{ goodDialogForm.goods_id || '无' }}</span>
                  </el-form-item>
                  <el-form-item label="报账简称：">
                    <span>{{ goodDialogForm.sub_title || '无' }}</span>
                  </el-form-item>
                  <el-form-item label="产品类别：">
                    <span>{{ goodDialogForm.srv_fullcase_str || '无' }}</span>
                  </el-form-item>
                  <el-form-item label="押金额：">
                    <span>{{ priceFormat(goodDialogForm.srv_price['押金']) || '无' }}</span>
                  </el-form-item>
                  <el-form-item label="服务费：">
                    <span>{{ priceFormat(goodDialogForm.srv_price['服务费']) || '无' }}</span>
                  </el-form-item>
                  <el-form-item label="报名费：">
                    <span>{{ priceFormat(goodDialogForm.srv_price['报名费']) || '无' }}</span>
                  </el-form-item>
                  <el-form-item v-if="showCommission" label="佣金：">
                    <span>{{ priceFormat(goodDialogForm.srv_price['佣金']) || '无' }}</span>
                  </el-form-item>
                  <el-form-item label="是否设置佣金：">
                    <span>{{ goodDialogForm.need_commission_str || '-' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="info" @click="dialogClose(2)">取 消</el-button>
              <el-button type="primary" :loading="btnLoading" @click="goodSave">保 存</el-button>
            </span>
          </el-dialog>
          <!--添加商品 end-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import 'element-ui/lib/theme-chalk/display.css';
import crumbs from '@/components/tool/crumbs';
import empty from '@/components/common/empty';
import tableList from '@/components/data/tableList';
import { formatSelectGroupData } from '@/utils/utils.js';
import schoolMultipleSearch from '@/components/tool/select/schoolMultipleSearch';

function getDefaultGoods() {
  return {
    commission_fee: '', // 佣金
    need_commission: '', // 是否需要佣金
    deposit_fee: '', // 押金
    goods_id: '', // 商品id
    goods_title: '', // 商品名称
    srv_price: {
      押金: '',
      服务费: '',
      报名费: ''
    },
    srv_fullcase: '', // 是否全案
    sub_title: '', // 商品简称
  };
}

export default {
  data() {
    return {
      loading: true,
      formData: {
        id: 0,
        crm_id: 0,
        create_uid: '',
        teacher_name: '',
        apply_school_ids: [],
        apply_school_list: [],
        is_plus: 2143,
        goods_list: [],
        order_title: '',
        order_memo: '',
        need_fee: '',
        deposit_fee: '',
        first_fee: '',
        is_renewal: 1,
        pre_fee: '',
        allograph_uid: '',
        allograph_office: '',
      },
      pageData: {},
      pageDs: {},
      btnLoading: false,
      goodDialogLock: false,
      goodDialogForm: getDefaultGoods(),
      goodsIndex: '',
    };
  },
  computed: {
    orderId() {
      if (this.$route.params === undefined) {
        return false;
      }
      return Number(this.$route.params.orderId);
    },
    id () {
      if (this.$route.params === undefined) {
        return false;
      }
      return Number(this.$route.params.id);
    },
    // 是否展示芥末佣金参考
    showCommission () {
      return this.$hasPermission([
        173, // 外联人员
        33, // 日本主管
        121, // 英美主管
        148, // 欧亚主管(日韩)
        22, // 韩国主管
        96, // 英美文书主管
        122, // 英美咨询主管
        101, // 日本咨询主管
        173, // 外联人员
        39, // 前程日本主管
        51, // 前程日本咨询主管
        81, // 运营质检
        62, // 运营监管
        171, // 财务报账审核
        4, // 财务总监
      ]);
    }
  },
  methods: {
    openGoodDialog() {
      this.goodDialogLock = true;
      this.goodDialogForm = getDefaultGoods();
      this.goodsIndex = '';
    },
    deleteGood(index) {
      this.formData.goods_list.splice(index, 1);
      this.changeGoodsList();
    },
    goodSave() {
      if (this.goodDialogForm.goods_title === '') {
        this.$message.error('请选择商品');
        return false;
      }
      let goods = Object.assign({}, this.pageDs.goods[this.goodsIndex]);
      this.formData.goods_list.push(goods);
      this.dialogClose(2);
      this.changeGoodsList();
    },
    // 关闭弹窗
    dialogClose(check) {
      switch (check) {
        case 1:
          // this.accountDialogLock = false;
          break;
        case 2:
          this.goodDialogLock = false;
          break;
        default:
          break;
      }
    },
    // 订单保存
    orderSave(data) {
      this.formData = Object.assign({}, this.formData, data);

      if (!this.formData.order_title) {
        this.$message.error('请填写订单名称');
        return false;
      }
      if (!this.formData.order_title.length > 200) {
        this.$message.error('订单名称字数不能超过200个字符');
        return false;
      }
      if (this.$hasPermission(1) && !this.formData.create_uid) {
        this.$message.error('请填写发起人');
        return false;
      }
      if (this.formData.goods_list.length < 1) {
        this.$message.error('请添加商品');
        return false;
      }
      if (!this.formData.is_renewal) {
        this.$message.error('请选择新单/补尾款');
        return false;
      }
      if (!this.formData.last_payment_date) {
        this.$message.error('请选择缴费截止日期');
        return false;
      }
      if (Number(this.formData.first_fee) < Number(this.formData.deposit_fee)) {
        // 已付金额为0
        this.$message.error('订单首款应大于等于押金总额');
        return false;
      }
      this.btnLoading = true;
      this.$http
        ._post({
          url: '/index/qc.order2022/save',
          data: this.formData
        })
        .then(() => {
          this.$router.push(`/student/payment/qcOrderList/${this.formData.crm_id}`);
          this.$message.success('保存成功');
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 计算应付总额和押金总额
    changeGoodsList() {
      let needFee = 0;
      let depositFee = 0;
      let firstFee = 0;
      let preFee = 0;
      this.formData.goods_list.forEach((item) => {
        needFee += Number(item.deposit_fee) + Number(item.service_fee) + Number(item.signup_fee);
        depositFee += Number(item.deposit_fee);
        firstFee += Number(item.deposit_fee);
        preFee += Number(item.service_fee) + Number(item.commission_fee);
      });
      this.formData.need_fee = needFee.toFixed(2);
      this.formData.deposit_fee = depositFee.toFixed(2);
      this.formData.first_fee = firstFee.toFixed(2);
      this.formData.pre_fee = preFee.toFixed(2);
    },
    // 获取页面数据
    async getFormData(orderId) {
      const { data } = await this.$http
        ._post({
          url: '/index/qc.order2022/find',
          data: { id: orderId }
        });
      return data;
    },
    goodChange(val) {
      this.goodsIndex = val;
      this.goodDialogForm = Object.assign({}, this.goodDialogForm, this.pageDs.goods[val]);
    },
    initDefault() {
      const userInfo = this.$store.getters.userInfo;
      this.formData.create_uid = userInfo.userid;
      this.formData.teacher_name = userInfo.username;
    },
    priceFormat(val) {
      if (val && val.indexOf(',') > -1) {
        let arr = val.split(',');
        if (arr[1] === '-1') {
          return `参考价格（${arr[0]}起）`;
        }
        return `参考区间（${arr[0]}~${arr[1]}）`;
      } else if (val === '-1') {
        return '金额不限';
      }
      return `参考价格（${val || '无'}）`;
    },
    schoolChange(val) {
      this.formData.apply_school_ids = val;
    },
    fetchOrderTitle() {
      if (this.formData.goods_list.length > 0) {
        this.formData.order_title = this.formData.goods_list.map((item) => {
          return item.goods_title;
        }).join(', ');
      }
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-empty': empty,
    'jm-tableList': tableList,
    schoolMultipleSearch
  },
  mounted() {
    this.loading = true;
    this.formData.crm_id = this.$route.params.id;
    this.initDefault();
    this.$http
      ._post({
        url: '/index/qc.order2022/findSearchDs',
        data: { crm_id: this.$route.params.id }
      })
      .then(async (res) => {
        if (res.result >= 0) {
          this.pageDs = res.data;
          this.pageDs.create_list = formatSelectGroupData(res.data.create_list);
          if (this.orderId) {
            this.formData = await this.getFormData(this.orderId);
            if (!this.formData.allograph_uid) {
              this.formData.allograph_uid = '';
            }
          }
        }
      })
      .catch(() => {
        setTimeout(() => {
          this.$router.push({ name: 'editStudent', params: { id: this.id } });
        }, 1000);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  watch: {
    'formData.goods_list': {
      handler: (val) => {
        val.forEach((item) => {
          item.need_fee = (Number(item.deposit_fee) + Number(item.service_fee) + Number(item.signup_fee)).toFixed(2);
        });
        return val;
      },
      deep: true
    }
  }
};
</script>
<style scoped>
  .info-manag-wrap .el-col {
    min-height: 41px;
    line-height: 36px;
    margin-bottom: 4px;
  }
  .info-manag-wrap .el-col label {
    min-width: 100px;
    text-align: right;
    margin: 0 14px 0 0;
    font-weight: 900;
    font-size: 12px;
    display: inline-block;
  }
</style>
